import { useTranslation, Trans } from "react-i18next";

import { ActionButtons } from "../../Common/ActionButtons";
import { Container, RightSide, LeftSide, Heading, Section } from "../../Common";
import { isTriviaGame } from "../../../../../../../graphql/helpers/isTriviaGame";
import { TriviaQuestionItem } from "./TriviaQuestionItem";
import { useGame } from "../../../../../../../contexts/game/GameContext";

import styles from "../AdvancedSettings.module.scss";

export const TriviaAdvancedSettings = () => {
  const { t: translation } = useTranslation("trivia");
  const t = (key: string) => translation(`advancedSettings.${key}`) as string;
  const { currentGame } = useGame();

  if (!currentGame || !isTriviaGame(currentGame)) {
    return null;
  }

  return (
    <Container>
      <RightSide />
      <LeftSide>
        <Heading
          title={{
            main: translation("project:advancedSettings.header1"),
            marked: translation("project:advancedSettings.header2"),
          }}
        >
          <Trans i18nKey={t("description")} />
        </Heading>

        <Section title={t("section")}>
          <div className={styles.attributes}>
            {currentGame.configuration.questions.map((question) => (
              <TriviaQuestionItem key={question.id} question={question} />
            ))}
          </div>
        </Section>

        <ActionButtons />
      </LeftSide>
    </Container>
  );
};
